import { createContext, useContext } from "react";
import { makeProvider, normalize } from "../helpers/makeContexts";

const dashusersettingInit = {
  dashboardusersettings: {},
  isLoadingDashboardUserSettings: false,
};

function dashboardusersettingReducer(draft, { type, payload }) {
  switch (type) {
    case "setDashboardUserSettings": {
      draft.dashboardusersettings = normalize(payload)
      break;
    }
    case "updateDashboardUserSettings": {
      payload.forEach((dus) => {
        draft.dashboardusersettings[dus.id] = dus
      })
      break;
    }
    case "setIsLoadingDashboardUserSettings": {
      draft.isLoadingDashboardUserSettings = payload;
      break;
    }
    default: {
      return null;
    }
  }
}

const [DashboardUserSettingContext, DashboardUserSettingDispatchContext] = [
  createContext(null),
  createContext(null),
];

export const DashboardUserSettingProvider = makeProvider(
  DashboardUserSettingContext, 
  DashboardUserSettingDispatchContext, 
  dashboardusersettingReducer, 
  dashusersettingInit
);

export function useDashboardUserSettingStore() {
  return useContext(DashboardUserSettingContext);
}

export function useDashboardUserSettingDispatch() {
  return useContext(DashboardUserSettingDispatchContext);
}